export default __webpack_public_path__ + "static/map-dm-cfa25dc3535bfc8dfec04066280cc384.png";